import { swapKeysAndValues } from "@helpers/common";

export const paginationLimit = 10;
export const initialOffset = 0;

export const REJECT_STATUS = 6;
export const SIGN_STATUS = 5;

export const hashConsentForms = "#consent-forms";
export const hashReceivedForms = "#received-forms";

export const consentFormsStatuses = {
  1: "pending",
  2: "approved",
  3: "failed",
  5: "signed",
  6: "rejected",
};

export const consentFormsMap = swapKeysAndValues(consentFormsStatuses);

export const documentTypes = {
  1: {
    label: "PASSPORT",
    value: 1,
  },
  2: {
    label: "ID",
    value: 2,
  },
  3: {
    label: "DRIVER_LICENSE",
    value: 3,
  },
};

export const documentFilesConfig = [
  {
    label: "DOCUMENT_FIRST_PAGE",
    name: "firstPageFileId",
  },
  {
    label: "DOCUMENT_SECOND_PAGE",
    name: "secondPageFileId",
  },
  {
    label: "SELFIE_WITH_ID",
    name: "selfieFileId",
  },
];
